import { BarChart3 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EmptyState from "../components/ui/EmptyState";

const Reports = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold" style={{ color: "var(--lm-ink)" }}>
          {t("miscPages.reports.pageTitle")}
        </h1>
        <p className="mt-1 text-sm" style={{ color: "var(--lm-ink-2)" }}>
          {t("miscPages.reports.pageSubtitle")}
        </p>
      </div>

      <EmptyState
        icon={BarChart3}
        title={t("miscPages.reports.title")}
        subtitle={t("miscPages.reports.subtitle")}
        action={{
          label: t("miscPages.reports.action"),
          onClick: () => navigate("/advanced-reports"),
        }}
      />
    </div>
  );
};

export default Reports;
